module.exports = __webpack_public_path__ + "b7016f10d6f581a8203931d8b75cce15.png";